import React from "react";
import { AlertTriangleIcon, CheckIcon, PackageCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { volumes } from "../../data/content";
export function Volumes() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-322" data-mp="2x0i81suxdmvw">
      <div className="mx-auto max-w-4xl" data-id="element-323" data-mp="2x34jw4oumojx">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-324" data-mp="2t0ga9usb9dlw">
          Everything You Need to Organize Your Pediatric Feeding Workflow
        </h2>
        <p className="mt-3 text-center font-display text-xl font-extrabold text-mint-700" data-id="element-325" data-mp="2j8tynxc29cim">
          6 PRACTICAL VOLUMES. ONE INTEGRATED SYSTEM.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-slate-700" data-id="element-326" data-mp="29bpc3weazf1a">
          Each volume addresses a specific stage of professional case organization. They’re operational resources built
          around assessment workflows, documentation templates, decision-support matrices, and practical planning tools.
        </p>

        <div className="mt-10 space-y-6" data-id="element-327" data-mp="335e3xoqnpqe2">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-plum-50 ring-1 ring-plum-100" data-id="element-328" data-mp="37w2un1uiijc5">
              <div className="bg-plum-700 px-5 py-4 text-white" data-id="element-329" data-mp="2u5hg1pc3cvk2">
                <p className="text-sm font-extrabold text-mint-300" data-id="element-330" data-mp="2u34smwnkdszm">VOLUME {v.number}</p>
                <h3 className="mt-1 font-display text-xl font-extrabold leading-snug sm:text-2xl" data-id="element-331" data-mp="2y4glrc5ncwck">{v.title}</h3>
              </div>
              <div className="p-5 sm:p-6" data-id="element-332" data-mp="3quyky2392dkp">
                <p className="font-display text-lg font-extrabold text-plum-900" data-id="element-333" data-mp="3quoukdeam4eh">{v.tagline}</p>
                <p className="mt-2 text-base leading-relaxed text-slate-700" data-id="element-334" data-mp="3cunw14li3926">{v.intro}</p>

                <p className="mt-5 text-sm font-extrabold text-plum-800" data-id="element-335" data-mp="3ht7h72s9sgth">Inside this volume:</p>
                <ul className="mt-2 grid gap-2 sm:grid-cols-2" data-id="element-336" data-mp="21f90m58xwp96">
                  {v.items.map(it => <li key={it} className="flex items-start gap-2 text-[15px] font-medium text-slate-800" data-id="element-337" data-mp="26g4zu5icjn89">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-mint-500" data-id="element-338" data-mp="byn780t8mmoq">
                        <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-339" data-mp="72ejw04vzn6h" />
                      </span>
                      {it}
                    </li>)}
                </ul>

                <p className="mt-5 text-[15px] leading-relaxed text-slate-700" data-id="element-340" data-mp="3pe1n2r6ni8j1">
                  <strong className="text-plum-900" data-id="element-341" data-mp="3pbym5c3ymuzj">Your practical outcome:</strong> {v.outcome}
                </p>

                <p className="mt-4 flex items-start gap-2 rounded-xl bg-white px-4 py-3 text-sm font-extrabold text-mint-700 ring-1 ring-mint-100" data-id="element-342" data-mp="3ffvl69kuh2e6">
                  <PackageCheckIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-343" data-mp="3bflesvt549ys" />
                  DELIVERABLE: {v.deliverable}
                </p>

                {v.note && <p className="mt-3 flex items-start gap-2 text-xs leading-relaxed text-amber-800" data-id="element-344" data-mp="19nyn0s1fcb19">
                    <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-345" data-mp="2rjh0hhkosbk0" />
                    {v.note}
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-346" data-mp="31b4y607u6otx">
          <CtaButton label="I Want All 6 Volumes Now" sub="Immediate digital access · $27" data-id="element-347" data-mp="35boyfcnpi8ka" />
        </div>
      </div>
    </section>;
}